module.exports = {"postcode":"Postcode","postcode_us":"Zip code","enter_postcode":"Enter postcode","enter_postcode_us":"Enter Zip code","dont_remember":"Don't remember?","select_province":"Select province below","select_province_us":"Select state below","address":"Address","address_enter":"Enter your address","incorrect_address":"Please double-check! The address does not seem to be correct","blocked_postal":"The postal code you entered is not valid"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/postalCode.json
// module id = 535
// module chunks = 245 961